import { PipeTransform } from '@angular/core';
import { QuestionTypeEnum } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { snakeCase } from 'lodash';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FormQuestionTypePipe = /** @class */ (function () {
    function FormQuestionTypePipe(fuseTranslationLoaderService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FormQuestionTypePipe.prototype.transform = function (type) {
        if (!type) {
            return null;
        }
        var constraintCaseType = snakeCase(QuestionTypeEnum[type]).toUpperCase();
        return this.translateService.instant("FORM_QUESTION_TYPE." + constraintCaseType);
    };
    return FormQuestionTypePipe;
}());
export { FormQuestionTypePipe };
